/**
 * Live Markets Info model
 */
export default class MarketInfoModel {
  constructor(data) {
    /**
     * odd id
     * @param {number}
     */
    this.otid = data.otid;
    /**
     * odd name
     * @param {string}
     */
    this.n = data.n;
    /**
     * invert odd order
     * @param {bool}
     */
    this.inv = data.sot;
    /**
     * first odd label
     * @param {string}
     */
    this.sn1 = data.sn1;
    /**
     * second odd label
     * @param {string}
     */
    this.sn2 = data.sn2;
  }
}